import React, { useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TopChartFilters from "@client.components/TopChartFilters";
import LeftSideBar from "../LeftSideBar";
import MeetingsDataTable from "./MeetingsDataTable";
import "./MeetingsPage.scss";
import { useDispatch } from "react-redux";
import { getUsersAsync } from "@client.pages/Settings/reducer";

const ReportsMeetings = () => {
  const [setTopBarTitle] = useOutletContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUsersAsync());
  }, [dispatch]);

  useEffect(() => {
    setTopBarTitle(t("components.NavigationBar.reports"));
  }, [t, setTopBarTitle]);

  return (
    <div className="reports">
      <LeftSideBar />
      <div className="reports-content">
        <TopChartFilters />
        <div className="meetings-page-content">
          <MeetingsDataTable />
        </div>
      </div>
    </div>
  );
};

export default ReportsMeetings;
